import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useRouter } from 'next/router';
import React from 'react';
import { LociListItem } from '../../types/loci-list-item.interface';
import Button from '../button/button.component';

type Props = {
  loci: LociListItem[];
  prev?: LociListItem;
  next?: LociListItem;
};

const LociTableComponent: React.FC<Props> = ({ loci, prev, next }) => {
  const router = useRouter();
  return (
    <table style={{ width: '100%' }}>
      <thead>
        <tr>
          <th>ID</th>
          <th>Trench</th>
          <th>Season</th>
          <th>Finds</th>
          <th>Interpretation</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {loci.map((locus, i) => (
          <tr key={locus.id}>
            <td>
              <span className="mobileLabel">ID</span>
              {locus.id}
            </td>
            <td>
              <span className="mobileLabel">Trench</span>
              {locus.trench}
            </td>
            <td>
              <span className="mobileLabel">Season</span>
              {locus.season}
            </td>
            <td>
              <span className="mobileLabel">Finds</span>
              {(locus.finds || ['-']).join(', ')}
            </td>
            <td>
              <span className="mobileLabel">Interpretation</span>
              {(locus.interpretation || ['-']).join(', ')}
            </td>
            <td>
              <Button
                small={true}
                btn={true}
                onClick={() => {
                  router.push({
                    pathname: `/loci/${locus.id}`,
                    query: {
                      prev: String(i !== 0 ? loci[i - 1].id : prev?.id),
                      next: String(
                        i !== loci.length - 1 ? loci[i + 1].id : next?.id
                      ),
                      ...router.query,
                    },
                  });
                }}
                css={{ width: '50px' }}
              >
                <FontAwesomeIcon icon={faMagnifyingGlass} />
              </Button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default LociTableComponent;
